import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/messaging'
import 'firebase/storage'

var config = {
  apiKey: process.env.VUE_APP_FB_APIKEY,
  authDomain: process.env.VUE_APP_FB_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FB_DATABASEURL,
  projectId: process.env.VUE_APP_FB_PROJECTID,
  storageBucket: process.env.VUE_APP_FB_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FB_MESSAGINSENDERID,
  appId: process.env.VUE_APP_FB_APPID
}

firebase.initializeApp(config)

const rtdb = firebase.database()
const db = firebase.firestore()
const storage = firebase.storage()
const auth = firebase.auth()
const fb = firebase
const firestore = firebase.firestore
let messaging = null
if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging()
}

if (process.env.VUE_APP_IS_EMULATOR === 'true') {
  auth.useEmulator('http://localhost:9099/')
  db.useEmulator("localhost", 8080);
  rtdb.useEmulator("localhost", 9000);
  storage.useEmulator("localhost", 9199);
}

export {
  rtdb,
  db,
  messaging,
  storage,
  auth,
  firestore,
  fb
}
